// Service worker registration + the "there's a new version" prompt (IDEA-003).
//
// Two jobs, one component, because they're two faces of the same thing: the
// registration is what makes the app installable and openable offline, and the
// prompt is the price of `registerType: "prompt"` — we control the reload, so
// something has to offer it.
//
// Mounted in main.tsx, outside the router: it's app chrome, not a page, and it
// has to work on /login too.

import { useRegisterSW } from "virtual:pwa-register/react";
import { AnimatePresence, motion } from "framer-motion";

export function AtualizacaoApp() {
  const {
    offlineReady: [prontoOffline, setProntoOffline],
    needRefresh: [precisaAtualizar, setPrecisaAtualizar],
    updateServiceWorker,
  } = useRegisterSW();

  const visivel = prontoOffline || precisaAtualizar;

  function dispensar() {
    setProntoOffline(false);
    setPrecisaAtualizar(false);
  }

  return (
    <AnimatePresence>
      {visivel && (
        <motion.div
          // Above everything, hugging the bottom on the phone where the app
          // actually lives. viewport-fit=cover is set in index.html, so the
          // home indicator needs accounting for by hand — and on the phone the
          // navigation bar sits down there too, so the toast clears both.
          className="fixed inset-x-0 bottom-0 z-50 flex justify-center px-4 pb-[calc(7.5rem+env(safe-area-inset-bottom))] sm:pb-[calc(1rem+env(safe-area-inset-bottom))]"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          role="status"
          aria-live="polite"
        >
          <div className="flex w-full max-w-md flex-col gap-3 rounded-2xl border border-ouro/40 bg-creme-50/95 p-4 shadow-[0_18px_40px_-18px_rgba(59,47,42,0.45)] backdrop-blur-sm sm:flex-row sm:items-center sm:gap-4">
            <p className="flex-1 text-sm text-tinta-700">
              {precisaAtualizar
                ? "Há uma nova versão da nossa história. ✨"
                : "Guardada no teu telemóvel — já abre sem ligação. 💛"}
            </p>

            <div className="flex shrink-0 items-center gap-2">
              {precisaAtualizar && (
                <button
                  type="button"
                  onClick={() => void updateServiceWorker(true)}
                  className="rounded-full bg-ouro px-5 py-2 text-sm font-semibold text-creme-50 shadow-[0_10px_28px_-10px_rgba(201,162,39,0.65)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-ouro-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ouro/60 focus-visible:ring-offset-2 focus-visible:ring-offset-creme"
                >
                  Atualizar
                </button>
              )}
              <button
                type="button"
                onClick={dispensar}
                className="rounded-full border border-ouro/40 px-5 py-2 text-sm font-semibold text-tinta transition-all duration-300 hover:border-ouro hover:bg-creme-200/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ouro/60 focus-visible:ring-offset-2 focus-visible:ring-offset-creme"
              >
                {precisaAtualizar ? "Agora não" : "Fechar"}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
